import React, { forwardRef, useEffect, useRef } from 'react';

import '../css/IndeterminateCheckbox.less';

import { SatCoreRegister } from '../SatCoreRegistry';

const IndeterminateCheckbox = forwardRef(
  ({ i18n, indeterminate, radio, t, tReady, ...rest } = {}, ref) => {
    const defaultRef = useRef();
    const inputRef = ref || defaultRef;

    useEffect(() => {
      if (!radio) {
        inputRef.current.indeterminate = indeterminate;
      }
    }, [inputRef, indeterminate, radio]);

    return (
      <div className={`IndeterminateCheckbox ${radio ? 'radio-mode' : ''}`}>
        <input ref={inputRef}
          onKeyDown={(event) => {
            if (inputRef.current && event?.key === 'Enter') {
              event.preventDefault?.();
              inputRef.current.click?.();
            }
          }}
          type='checkbox'
          {...rest}
        />
        <span className={`${radio ? 'indeterminate-checkbox-radio-span' : 'indeterminate-checkbox-span'}`} />
      </div>
    );
  }
);
IndeterminateCheckbox.displayName = 'IndeterminateCheckbox';

export default IndeterminateCheckbox;

SatCoreRegister('IndeterminateCheckbox', IndeterminateCheckbox);
